// import { type } from "@testing-library/user-event/dist/type";
import Pagination from "../../Pagination";
import { CustomerContext } from "./CustomerContext";
import React, { useContext } from "react"
import { Link } from "react-router-dom";
import "./customerBanks.css"
export default function CustomerBanks() {


  const { availableBanks, formik, setRelToDel, postsPerPage, currentPage, paginate, customerBanksData, newCustomerBanksData } = useContext(CustomerContext)
  const shouldPaginate = customerBanksData.length > 4
  const foundBankNames = availableBanks.length>0 ? availableBanks.map((bank) => bank.name) : null
  // console.log(customerBanksData)
  const displayedBanks = shouldPaginate ? newCustomerBanksData : customerBanksData
 // console.log(displayedBanks)
  return (
    <div className="  mb-10 mt-2">
      <div>
        <Link to="/customerDash/communicate/bankOwners" className="hover:text-blue-500">BankOwners</Link>
      </div>
      <div >
      <div>
          {displayedBanks.length > 0 ?
                  <div className="bank-grid max-w-full min-w-fit flex flex-auto">
                    {displayedBanks.map((bank, index) => (
                      <div className="bank-card max-w-full min-w-fit" key={index}>
                        <div className="bank-container">
                          <div className="top-0 right-5">                    
                            <form onSubmit={formik.handleSubmit}>
                              <button className="bg-red-500 text-white rounded-lg" onClick={() => {
                                formik.setFieldValue("name", bank.name);
                                setRelToDel(true);
                              }} type="submit">DELETE</button>
                            </form>
                          </div>
                          <img src={bank.image_url} alt={bank.name} className="bank-image max-w-full min-w-fit" />
                          <div key={index} className="data-overlay">
                            <p className="text-white italic">{bank.name}</p>
                            <h4 className="text-white italic">{bank.location}</h4>
                            <p className="text-white italic">{bank.email}</p>
                            <p className=" text-white italic">{bank?.paybill}</p>
                          </div>
      
      
                        </div>
                      </div>
      
                    ))}
                  </div>
                   :
                  <p>Sorry, you seem to have no banks, want to add</p>}
      
      
              </div>
      </div>
      {shouldPaginate ? <Pagination postsPerPage={postsPerPage} totalPosts={customerBanksData.length} currentPage={currentPage} paginate={paginate} /> : null}
      {availableBanks.length > 0 ?
        <form onSubmit={formik.handleSubmit} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
          <select value={formik.name} name="name" id="name" onChange={formik.handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
            <option>Select a bank</option>
            {foundBankNames.map((bank, index) => (
              <option key={index} value={bank}>{bank}</option>
            ))}
          </select>
          <button className="bg-blue-500 rounded-lg disabled:opacity-50" disabled={formik.isSubmitting || !formik.isValid} type="submit">Send Request</button>
        </form>
        : null}

    </div>
  )
}


